module.exports = __webpack_public_path__ + "static/img/storPng.8d48fc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/storPng.png
// module id = 24do
// module chunks = 1